/* Timber custom: open the desktop nav dropdowns on hover (July 2026).
   Dawn's top-level menu items are <details>/<summary> disclosures that open on
   click only. On hover-capable desktop pointers this opens them on mouseenter
   and closes on mouseleave (with a short grace delay so diagonal travel into
   the panel doesn't flicker). Click, touch, and keyboard behavior are left
   exactly as Dawn wires them — the shims only add/remove the open attribute,
   the same thing a summary click does. Loaded by sections/header.liquid. */
(function () {
  'use strict';

  var desktop = window.matchMedia('(min-width: 990px)');
  var hoverable = window.matchMedia('(hover: hover) and (pointer: fine)');

  function hoverActive() {
    return desktop.matches && hoverable.matches;
  }

  /* The mega-menu dropdown column aligns under the first nav item's label
     (the menu is centered, so its x-position depends on viewport and menu
     width). Measured here and published as --mega-menu-left for
     component-mega-menu.css; recomputed on open and on resize so the sticky
     header's logo shrink can't leave it stale. */
  function setMenuOffset() {
    var first = document.querySelector('.header__inline-menu .header__menu-item');
    if (!first) return;
    var left = first.getBoundingClientRect().left + parseFloat(window.getComputedStyle(first).paddingLeft || '0');
    document.documentElement.style.setProperty('--mega-menu-left', Math.max(0, Math.round(left)) + 'px');
  }

  setMenuOffset();
  window.addEventListener('resize', setMenuOffset);

  function enable(details) {
    var summary = details.querySelector('summary');
    var root = details.closest('header-menu') || details;
    var closeTimer = null;

    /* Covers click/keyboard opens too, not just hover. */
    details.addEventListener('toggle', function () {
      if (details.hasAttribute('open')) setMenuOffset();
    });

    root.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      if (!hoverActive()) return;
      if (!details.hasAttribute('open')) {
        setMenuOffset();
        details.setAttribute('open', '');
        if (summary) summary.setAttribute('aria-expanded', 'true');
      }
    });

    root.addEventListener('mouseleave', function () {
      clearTimeout(closeTimer);
      if (!hoverActive()) return;
      closeTimer = setTimeout(function () {
        details.removeAttribute('open');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      }, 150);
    });
  }

  document.querySelectorAll('.header__inline-menu header-menu > details').forEach(enable);
})();
